import { Navigate, useLocation } from 'react-router-dom';
import { useCurrentUser } from '../hooks/useCurrentUser';

/**
 * Phase 66 D-07: route-level guard for ACCOUNTANT role.
 *
 * ACCOUNTANT (bookkeeper) only has access to /invoices, /documents and /settings.
 * Any other location pathname triggers a redirect to /invoices.
 *
 * Non-ACCOUNTANT users (ADMIN/TEAM_LEAD/MANAGER + unauthenticated) pass through
 * unchanged. Wraps <Routes> at App.jsx top level — single instance for the SPA.
 */
const ACCOUNTANT_ALLOWED_PREFIXES = ['/invoices', '/documents', '/settings'];

export function AccountantRouteGuard({ children }) {
  const { isAccountant, isLoading } = useCurrentUser();
  const location = useLocation();

  if (isLoading) return null;
  if (!isAccountant) return children;

  const allowed = ACCOUNTANT_ALLOWED_PREFIXES.some((p) =>
    location.pathname === p || location.pathname.startsWith(`${p}/`)
  );

  return allowed ? children : <Navigate to="/invoices" replace />;
}
